import { AddingState, TOGGLE_ADDING_DIALOG, AddingDialogActions, TOGGLE_ADDING_PENDING, ADD_TORRENT_SUCCESS, ADD_TORRENT_ERROR, RESET_ADDING_STATE } from "../types";


const initState: AddingState = {
  show: false,
  pending: false,
  added: undefined,
  error: undefined,
}

export default function addingReducer(state = initState, action: AddingDialogActions): AddingState {
  switch (action.type) {
    case TOGGLE_ADDING_DIALOG:
      return {
        ...state,
        show: action.show,
      };
    case TOGGLE_ADDING_PENDING:
      return {
        ...state,
        pending: action.pending,
      }
    case ADD_TORRENT_SUCCESS:
      return {
        ...state,
        added: action.added,
      }
    case ADD_TORRENT_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case RESET_ADDING_STATE:
      return initState;
    default:
      return state;
  }
}